import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { CheckMailProps } from "models/propTypes/loginPropTypes";
//#endregion
//#region components
import { ActionLinkButton, Icon } from "components/common";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const CheckMail: React.FC<CheckMailProps> = (props) => {
  return (
    <>
      <Grid container className={cssExports.topContent}>
        <ActionLinkButton onClick={props.goBack} startIcon={<Icon icon={IconDefinitionConstants.WChevronLeft} />}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.Login)}
        </ActionLinkButton>
      </Grid>
      <Grid container spacing={4}>
        <Grid container item>
          <Grid container spacing={1}>
            <Grid item container className={cssExports.loginHeader}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.CheckYourMail)}
            </Grid>
            <Grid item container className={cssExports.loginMessage}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.CheckYourMailMessage)}
            </Grid>
            <Grid container item>
              <ActionLinkButton
                onClick={props.goBack}
                endIcon={<Icon icon={IconDefinitionConstants.WArrowSmallRight} />}
              >
                {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.BackToLogin)}
              </ActionLinkButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default CheckMail;
